<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header align-items-center d-flex">
				<h4 class="card-title mb-0 flex-grow-1">Prospects</h4>
			</div>
			<!-- end card header -->

			<div class="card-body">
				<div class="col-md-12 ml-auto mr-auto">
					<div class="ngxtable">
						<br>
						<div class="row">
							<div class="col-4">
								<app-select-search [values]="campaigns" (onSelected)="setCampaign($event)" [startValue]="selectedCampaign ? selectedCampaign : '0'"></app-select-search>
							</div>
							<div class="col-5" align="left">
								<div ngbDropdown class="d-inline-block">
									<button type="button" class="btn btn-outline-primary" id="dropdownForm1" ngbDropdownToggle>Criterias</button>
									<div ngbDropdownMenu aria-labelledby="dropdownForm1" class="dpContainer">
										<div class="row">
											<div class="row">
												<div class="col-12">
													<span style="margin-right: 40px"><input type="radio" class="selectors" [(ngModel)]="criterias.prospects_from" value="LMS" /> LMS Database</span>
													<span style="margin-right: 40px" *ngIf="this.selectedCampaign != 0"><input type="radio" class="selectors" [(ngModel)]="criterias.prospects_from" value="CLIENT" /> Uploaded Campaigns Lists</span>
												</div>
											</div>
											<hr />

											<div class="row criteria-height">
												<div class="col-6">
													<span class="form-check form-switch switch-position">
														<input class="form-check-input" type="checkbox" role="switch" [checked]="this.criterias.section_employee_size" (click)="criteriaSelected('employee_size')" />
														Employee Size
													</span>
												</div>
												<div class="col-3">
													<label for="" class="criterias-labels">Min Employees</label>
													<input type="number" class="form-control" placeholder="Min Employees" [(ngModel)]="criterias.employee_size_min" [disabled]="!this.criterias.section_employee_size" />
												</div>
												<div class="col-3">
													<label for="" class="criterias-labels">Max Employees</label>
													<input type="number" class="form-control" placeholder="Max Employees" [(ngModel)]="criterias.employee_size_max" [disabled]="!this.criterias.section_employee_size" />
												</div>
											</div>

											<div class="row criteria-height">
												<div class="col-6">
													<span class="form-check form-switch switch-position">
														<input class="form-check-input" type="checkbox" role="switch" [checked]="this.criterias.section_asset_size" (click)="criteriaSelected('asset_size')" />
														Asset Size
													</span>
												</div>
												<div class="col-3">
													<label for="" class="criterias-labels">Min Assets</label>
													<input type="number" class="form-control" placeholder="Min Assets" [(ngModel)]="criterias.asset_size_min" [disabled]="!this.criterias.section_asset_size" />
												</div>
												<div class="col-3">
													<label for="" class="criterias-labels">Max Assets</label>
													<input type="number" class="form-control" placeholder="Max Assets" [(ngModel)]="criterias.asset_size_max" [disabled]="!this.criterias.section_asset_size" />
												</div>
											</div>

											<div class="row criteria-height">
												<div class="col-6">
													<span class="form-check form-switch switch-position">
														<input class="form-check-input" type="checkbox" role="switch" [checked]="this.criterias.section_plan_participants" (click)="criteriaSelected('plan_participants')" />
														Plan Participants
													</span>
												</div>
												<div class="col-3">
													<label for="" class="criterias-labels">Min Participants</label>
													<input type="number" class="form-control" placeholder="Min Participants" [(ngModel)]="criterias.plan_participants_min" [disabled]="!this.criterias.section_plan_participants" />
												</div>
												<div class="col-3">
													<label for="" class="criterias-labels">Max Participants</label>
													<input type="number" class="form-control" placeholder="Max Participants" [(ngModel)]="criterias.plan_participants_max" [disabled]="!this.criterias.section_plan_participants" />
												</div>
											</div>

											<div class="row criteria-height">
												<div class="col-6">
													<span class="form-check form-switch switch-position">
														<input class="form-check-input" type="checkbox" role="switch" [checked]="this.criterias.section_state" (click)="criteriaSelected('state')" />
														State
													</span>
												</div>
												<div class="col-6">
													<label for="" class="criterias-labels">State</label>
													<app-select-search [values]="states" [fieldValue]="'shortName'" [disabled]="!this.criterias.section_state"
													[multiple]="true" [closeOnSelect]="false" [searchable]="false" (onSelected)="setStatesFromArray($event)"></app-select-search>
													<!-- <ng-select
														[items]="states"
														[multiple]="true"
														[closeOnSelect]="false"
														[searchable]="false"
														bindLabel="name"
														placeholder="Select people"
														[(ngModel)]="criterias.state">
													</ng-select> -->
												</div>
											</div>

											<div class="row criteria-height">
												<div class="col-6">
													<span class="form-check form-switch switch-position">
														<input class="form-check-input" type="checkbox" role="switch" [checked]="this.criterias.section_zip_code" (click)="criteriaSelected('zip_code')" />
														Zip Code
													</span>
												</div>
												<div class="col-3">
													<label for="" class="criterias-labels">Zip Code</label>
													<input type="text" class="form-control" placeholder="Zip Code" [(ngModel)]="criterias.zip_code" [disabled]="!this.criterias.section_zip_code" />
												</div>
												<!-- <div class="col-3">
													<label for="" class="criterias-labels">Radius</label>
													<input type="text" class="form-control" placeholder="Radius" [(ngModel)]="criterias.radius" [disabled]="!this.criterias.section_zip_code" />
												</div> -->
											</div>
										</div>
									</div>
								</div>
								<button (click)="searchProspects()" type="button" class="btn btn-primary waves-effect waves-light" style="margin-left: 10px;"><i class="bx bx-search-alt-2"></i> </button>
							</div>
							<div class="col-3" align="right">
								<button (click)="open(selectCampaign)" type="button" class="btn btn-primary btn-label waves-effect waves-light" *ngIf="selectedCampaign == 0" placement="top" ngbTooltip="Assign search to campaign">
									<i class="ri-file-add-line label-icon align-middle fs-16 me-2"></i>
									Assign
								</button>
								<button (click)="open(deleteProspects)" type="button" class="btn btn-danger btn-label waves-effect waves-light" *ngIf="selectedCampaign != 0" placement="top" ngbTooltip="Unassign from campaign">
									<i class="ri-file-reduce-line label-icon align-middle fs-16 me-2"></i>
									Unassign
								</button>
							</div>
						</div>

						<div class="row">
							<div class="col-12">
								<div class="alert alert-info mt-3" style="font-weight: 800">
									<span *ngIf="criterias.prospects_from == 'LMS'">Searching prospects from LMS Database</span>
									<span *ngIf="criterias.prospects_from == 'CLIENT'">Searching prospects from a client List</span>
									<p style="margin: 0px;">
										<small>
											<span *ngIf="criterias.section_state"><strong>State: </strong> {{ criterias.state }}<br></span>
											<span *ngIf="criterias.section_zip_code"><strong>Zip: </strong> {{ criterias.zip_code }} <br></span>
											<span *ngIf="criterias.section_employee_size"><strong>Employee Size: </strong> {{ criterias.employee_size_min }} - {{ criterias.employee_size_max }} <br></span>
											<span *ngIf="criterias.section_asset_size"><strong>Plan Assets: </strong> {{ criterias.asset_size_min }} - {{ criterias.asset_size_max }} <br></span>
											<span *ngIf="criterias.section_plan_participants"><strong>Plan Participants: </strong> {{ criterias.plan_participants_min }} - {{ criterias.plan_participants_max }} <br></span>
										</small>
									</p>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-10">
								<p style="margin: 0px; padding: 0px; font-size: 11px">Hide Columns (Click on the column You want to See):</p>
								<p>
									<span *ngFor="let column of columns" class="badge" (click)="toggleColumn(column.prop)" [ngClass]="{ 'bg-primary': column.visible, 'bg-danger': !column.visible }" style="cursor: pointer; margin-right: 5px">
										{{ column.name }}
									</span>
								</p>
							</div>
							<div class="col-2 d-flex align-items-end justify-content-end">
								<button (click)="exportToExcel()" type="button" class="btn btn-success btn-label waves-effect waves-light">
									<i class="ri-file-excel-fill label-icon align-middle fs-16 me-2"></i>
									Export
								</button>
							</div>
						</div>

						<div style="width: 100%; overflow-x: auto">
							<ngx-datatable #prospectsTable [rows]="prospects" [scrollbarH]="true" [columns]="essentialColumns" [loadingIndicator]="loading" class="material" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [limit]="100">
								<ngx-datatable-column prop="id" name="ID" headerClass="title-header" [width]="100">
									<ng-template let-row="row" ngx-datatable-cell-template> {{ row.id }} </ng-template>
								</ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="title-header" cellClass="cell-table" name="Company Name" prop="company_name" [width]="200" *ngIf="isShowed('company_name')"> </ngx-datatable-column>

								<ngx-datatable-column prop="name" name="Name" headerClass="title-header" cellClass="cell-table" [width]="150">
									<ng-template let-row="row" ngx-datatable-cell-template> {{ row.title }} {{ row.first_name }} {{ row.last_name }} </ng-template>
								</ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center cell-table" name="Primary Phone" prop="primary_phone" [width]="150" *ngIf="isShowed('primary_phone')">
									<ng-template let-row="row" ngx-datatable-cell-template> {{ row.primary_phone | phone }} </ng-template>
								</ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="title-header" cellClass="cell-table" name="Primary Email" prop="primary_email" [width]="150" *ngIf="isShowed('primary_email')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="title-header" cellClass="cell-table" name="City" prop="city" [width]="100" *ngIf="isShowed('city')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center cell-table" name="State" prop="state" [width]="100" *ngIf="isShowed('state')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center cell-table" name="Zip" prop="zip" [width]="100" *ngIf="isShowed('zip')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center cell-table" name="Employees" prop="employee_size" *ngIf="isShowed('employee_size')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center cell-table" name="Last Dispo" prop="last_dispo" *ngIf="isShowed('last_dispo')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center cell-table" name="EIN" prop="EIN" *ngIf="isShowed('EIN')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center cell-table" name="Business Code" prop="business_code" *ngIf="isShowed('business_code')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="title-header" cellClass="cell-table" name="Business Desc" prop="business_code_description" [width]="200" *ngIf="isShowed('business_code_description')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="title-header" cellClass="cell-table" name="Website" prop="website_url" *ngIf="isShowed('website_url')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center cell-table" name="Country" prop="country_code" *ngIf="isShowed('country_code')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center cell-table" name="Alt Phone" prop="alt_phone" *ngIf="isShowed('alt_phone')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="title-header" cellClass="cell-table" name="Address 1" prop="address_1" *ngIf="isShowed('address_1')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="title-header" cellClass="cell-table" name="Address 2" prop="address_2" *ngIf="isShowed('address_2')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="title-header" cellClass="cell-table" name="Province" prop="province" *ngIf="isShowed('province')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center cell-table" name="Alt Contact" prop="alt_contact" *ngIf="isShowed('alt_contact')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center cell-table" name="Direct Line" prop="direct_line" *ngIf="isShowed('direct_line')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center cell-table" name="Extension" prop="ext" *ngIf="isShowed('ext')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center cell-table" name="Mobile Phone" prop="mobile_phone" *ngIf="isShowed('mobile_phone')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="title-header" cellClass="cell-table" name="Alt Email" prop="alt_email" *ngIf="isShowed('alt_email')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center cell-table" name="Annual Revenue" prop="annual_revenue" *ngIf="isShowed('annual_revenue')">
									<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
										{{ formatCurrency(value) }}
									</ng-template>
								</ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center cell-table" name="Plan Assets" prop="plan_assets" *ngIf="isShowed('plan_assets')">
									<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
										{{ formatCurrency(value) }}
									</ng-template>
								</ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center cell-table" name="Plan Participants" prop="plan_participants" *ngIf="isShowed('plan_participants')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="title-header" cellClass="cell-table" name="Provider 1" prop="provider_1" *ngIf="isShowed('provider_1')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="title-header" cellClass="cell-table" name="Provider 2" prop="provider_2" *ngIf="isShowed('provider_2')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="Renewal Month 1" prop="renewal_month_1" *ngIf="isShowed('renewal_month_1')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="Renewal Year 1" prop="renewal_year_1" *ngIf="isShowed('renewal_year_1')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="Renewal Month 2" prop="renewal_month_2" *ngIf="isShowed('renewal_month_2')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="Renewal Year 2" prop="renewal_year_2" *ngIf="isShowed('renewal_year_2')"> </ngx-datatable-column>

								<ngx-datatable-column [sortable]="true" headerClass="cell-center title-header" cellClass="cell-center " name="Available Date" prop="available_date" *ngIf="isShowed('available_date')">
									<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
										{{ formatDate(value) }}
									</ng-template>
								</ngx-datatable-column>
							</ngx-datatable>
						</div>
					</div>
				</div>
			</div>
			<!-- end card-body -->
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
</div>
<!--end row-->

<!-- MODALS -->

<ng-template #selectCampaign let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Assign prospects to campaign</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<label for="campaign">Campaign</label>
		<app-select-search [values]="campaignsModal" (onSelected)="setCampaignModal($event)"></app-select-search>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-secondary" (click)="assignToCampaign()">Assign</button>
	</div>
</ng-template>

<ng-template #deleteProspects let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Unassign Prospects</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<p>Are you sure you want to Unassign these prospects?</p>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-secondary" (click)="unassignFromCampaign()">Unassign</button>
	</div>
</ng-template>

<ng-template #popTitle
	><p>
		<small>
			<strong>State: </strong> (state=TX,CA,WA) <br />
			<strong>Zip: </strong> (zip=94102) <br />
			<strong>Employee Size: </strong> (employees=100-500) <br />
			<strong>Plan Assets: </strong> (assets=100000-500000) <br />
			<strong>Plan Participants: </strong> (participants=100-500) <br />
		</small></p
></ng-template>
